module.exports = __webpack_public_path__ + "static/img/jdsk.c7e9a4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/jdsk.jpg
// module id = BumN
// module chunks = 1